/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Plan_Change_Cancel_ErrorInputs */

const fr_membership_plan_change_cancel_error = /** @type {(inputs: Membership_Plan_Change_Cancel_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d'annuler le changement de formule. Veuillez réessayer plus tard.`)
};

/**

* @param {Membership_Plan_Change_Cancel_ErrorInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_plan_change_cancel_error = /** @type {((inputs?: Membership_Plan_Change_Cancel_ErrorInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Plan_Change_Cancel_ErrorInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_plan_change_cancel_error(inputs)
});